import { useState, useEffect, useRef } from "react";
export default function CallToAction() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section style={{
    backgroundColor: "rgb(46, 77, 56)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(249, 249, 246)",
    fontFamily: "Inter, sans-serif",
    paddingTop: "96px",
    paddingBottom: "96px",
    textAlign: "center"
  }} className="!bg-[rgba(65,158,231,1)]">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=Inter:wght@400;500&display=swap');
        .cta-button {
          transition: color 0.15s cubic-bezier(0.4, 0, 0.2, 1),
                      background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1),
                      border-color 0.15s cubic-bezier(0.4, 0, 0.2, 1),
                      opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);
          display: inline-block;
          cursor: pointer;
          text-decoration: none;
        }
        .cta-button:hover {
          background-color: rgb(80, 93, 78);
          opacity: 0.9;
        }
      `}</style>
      <div className="page-container">
        <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <h2 style={{
          color: "rgb(249, 249, 246)",
          fontFamily: '"Playfair Display", serif',
          fontSize: "48px",
          fontWeight: "700",
          lineHeight: "48px",
          border: "0px solid rgb(222, 222, 211)",
          textAlign: "center",
          marginBottom: "24px"
        }}>Ready to Get Your Garden Machinery Running Again?</h2>
          <p style={{
          color: "rgba(249, 249, 246, 0.8)",
          fontFamily: "Inter, sans-serif",
          fontSize: "20px",
          fontWeight: "400",
          lineHeight: "28px",
          border: "0px solid rgb(222, 222, 211)",
          textAlign: "center",
          maxWidth: "560px",
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: "40px"
        }}>Contact Carlisle's trusted machinery repair specialists for a fast, no-obligation quote. Drop it off or get in touch — we'll have it fixed and back with you quickly.</p>
          <a href="#" className="cta-button !bg-[rgba(0,0,0,1)]" style={{
          color: "rgb(249, 249, 246)",
          fontFamily: "Inter, sans-serif",
          fontSize: "18px",
          fontWeight: "500",
          lineHeight: "28px",
          backgroundColor: "rgb(94, 107, 91)",
          border: "1px solid rgb(75, 85, 73)",
          padding: "24px 40px",
          textAlign: "center",
          borderRadius: "0px"
        }}>
            Get in Touch
          </a>
        </div>
      </div>
    </section>;
}